<template>
	<div class="app">
		<Card dis-hover>
			<p slot="title">
				<Icon type="ios-bookmark"></Icon> 我的假期额度
			</p>

			<div class="table_body">
				<Table ref="table" border :loading="loading" :columns="columns" :no-data-text="NoDatas"
					:data="tableBody_item"></Table>

				<div style="margin-top: 10px;">
					<!-- <Page  show-sizer show-elevator show-total :current="current" :total="totalCount" @on-change="pageChange" @on-page-size-change="pagesizeChange"></Page> -->
				</div>
			</div>
		</Card>
		<!-- 操作日志弹出框 -->
		<operation :value="testLog" @close="closeLog" ref="logID"></operation>
	</div>
</template>
<script>
	import moment from 'moment'
	import operation from './operation.vue'
	export default {
		name: 'mypersonholiday',
		props: {},
		components: {
			operation
		},
		filters: {
			formData(val) {
				return moment(val).format('YYYY-MM-DD')
			},
		},
		data() {
			return {
				totalCount: 0, //总共多少页
				current: 1, //当前第几页
				form: {
					Name: '',
					Year: '',
					SkipCount: 0, //从第几条开始爬
					MaxResultCount: 10, //一页多少条
					Query_我的假期额度: true,
				},
				NoDatas: '暂无数据',
				testLog: false,
				loading: false,
				columns: [],
				tableBody_item: [],
				fromFields: {},
			}
		},
		mounted() {
			this.getColumns() //列表数据初始化
			this.getData()
		},
		methods: {
			//页数
			pageChange(size) {
				this.form.SkipCount = (size - 1) * this.form.MaxResultCount
				this.getData()
			},
			//每页最大条数
			pagesizeChange(size) {
				this.form.MaxResultCount = size
				this.getData()
			},
			//打开日志弹出框
			openLog(type, data) {
				this.testLog = true;
				this.$refs.logID.getLogID(data.id)
			},
			//关闭关闭弹出框
			closeLog(data){
				this.testLog = false;
				},
			//列表数据
			async getData() {
				this.loading = true
				let findData = await this.$Ajax.get(`/api/services/app/UserLeave/QueryDto?IncludeLeaveUser=${true}`, {
					params: this.form
				});
				this.tableBody_item = findData.data.result.items
				this.totalCount = findData.data.result.totalCount
				this.loading = false
			},

			//table 列
			getColumns() {
				this.columns = [{
						title: "操作",
						key: "Actions",
						width: 150,
						align: 'center',
						render: (h, params) => {
							return h("div", [
								h(
									"Button", {
										props: {
											type: "primary",
											size: "small",
										},
										style: {
											marginRight: "5px",
										},
										on: {
											click: async () => {
												this.openLog('日志', params.row) //打开操作日志弹出框
											},
										},
									},
									"日志"
								),
							]);
						},
					},
					{
						title: "用户名",
						width: 90,
						key: "name",
						render: (h, params) => {
							return h("span", params.row.leaveUser.name);
						},

					},
					{
						title: "年份",
						width: 90,
						key: "year",
					},
					{
						title: "年假天数",
						width: 90,
						key: "annualLeave",
					},
					{
						title: "年假已用天数",
						width: 90,
						key: "annualLeaveUsed",
					},
					{
						title: "年假剩余天数",
						width: 90,
						key: "timeRemainingAllnual",
					},
					{
						title: "调休天数",
						width: 90,
						key: "overtimeLeave",
					},
					{
						title: "调休已用天数",
						width: 90,
						key: "overtimeLeaveUsed",
					},
					{
						title: "调休剩余天数",
						width: 90,
						key: "timeRemainingOvertime",
					},
					{
						title: "去年结余年假",
						width: 90,
						key: "lastYearAnnualLeave",
					},
					{
						title: "结余已用年假",
						width: 90,
						key: "lastYearAnnualLeaveUsed",
					},
					{
						title: "结余剩余年假",
						width: 90,
						key: "timeRemainingLastYearAnnual",
					},
					{
						title: "已用事假",
						key: "matterLeaveUsed",
					},
					{
						title: "已用婚假",
						width: 90,
						key: "marriageLeaveUsed",
					},
					{
						title: "已用产假",
						width: 90,
						key: "maternityLeaveUsed",
					},
					{
						title: "已用丧假",
						width: 90,
						key: "funeralLeaveUsed",
					},
					{
						title: "已用陪产假",
						width: 90,
						key: "paternityLeaveUsed",
					},
					{
						title: "已用哺乳假",
						width: 90,
						key: "breastfeedingLeaveUsed",
					},
					{
						title: "已用病假",
						width: 90,
						key: "sickLeaveUsed",
					},
					{
						title: "已用工伤假",
						width: 90,
						key: "workInjuryLeaveUsed",
					},
					{
						title: "过期日期",
						width: 120,
						key: "expirationTime",
						render: (h, params) => {
							return h("span",
								moment(params.row.expirationTime).format("YYYY-MM-DD"));
						}
					},

				]
			},
		},
	}
</script>

<style lang="less" scoped="scoped">
	.app {
		min-width: 900px;
	}
</style>